module.exports = __webpack_public_path__ + "assets/img/image21.0b4b2835.png";